import { render } from "./ModalNotificationInvalidPostalCode.vue?vue&type=template&id=addb1c6e&scoped=true"
import script from "./ModalNotificationInvalidPostalCode.vue?vue&type=script&lang=js"
export * from "./ModalNotificationInvalidPostalCode.vue?vue&type=script&lang=js"

import "./ModalNotificationInvalidPostalCode.vue?vue&type=style&index=0&id=addb1c6e&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-addb1c6e"]])

export default __exports__